module.exports = __webpack_public_path__ + "static/img/notice-icon.08699b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notice-icon.png
// module id = nLeL
// module chunks = 1